var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"select",class:[!_vm.address ? 'is-invalid': 'origin-selected', 'originSelect', 'custom-dropdown'],attrs:{"clearable":false,"options":_vm.options,"label":"text","onChange":_vm.onChange,"placeholder":"Please Select an Origin Address"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80d9f620","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Form/OriginSelect.vue
// module id = IyQ5
// module chunks = 1